import shopQueries from '@apis/queries/shopQueries';
import ShopApi from '@apis/shop/ShopApi';
import { userLatLonAtom } from '@atoms/locationAtoms';
import useTestUser from '@hooks/test/useTestUser';
import useDebouncedValue from '@hooks/useDebouncedValue';
import useResetPage from '@hooks/useResetPage';
import { GetShopsParams } from '@models/shop';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/slice';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

import { isMyShopAtom, queryAtom } from '../../../atoms/shopsInMapAtoms';

interface Props {
  locationAgreed: boolean,
  originalItemId?: string,
  isOrder?: boolean
  ready: boolean,
}

function useShops({
    locationAgreed, originalItemId, isOrder, ready,
}: Props) {
    const [page, setPage] = useState<number>(0);
    const query = useAtomValue(queryAtom);
    // 검색어를 지웠을 때는 디바운스 없이 바로 반영해, 이전 검색어로 한 번 더 조회하지 않게 한다
    const debouncedValue = useDebouncedValue(query);
    const debouncedQuery = query ? debouncedValue : '';
    const myShop = useAtomValue(isMyShopAtom);
    const { lat, lon } = useAtomValue(userLatLonAtom);
    const params: GetShopsParams = {
        page,
        size: 10,
        lon,
        lat,
        query: debouncedQuery,
        myShop,
        originalItemId,
        locationAgreed,
        searchType: isOrder ? 'ORDER' : 'SEARCH_SHOP',
    };
    const queryInfo = useInfiniteQuery({
        queryKey: shopQueries.listInfinite(params).queryKey,
        queryFn: ({ pageParam }) => ShopApi.getShops({
            ...params,
            page: pageParam,
        }),
        initialPageParam: 0,
        enabled: ((!debouncedQuery) || debouncedQuery.length >= 2)
        && (ready || import.meta.env.MODE === 'development'),
        getNextPageParam,
    });
    const isTestUser = useTestUser();
    const shops = getFlattenPageResponse(queryInfo);
    const isBlank = getIsBlank(queryInfo);

    useResetPage({ params, setPage });
    return {
        ...queryInfo,
        shops: shops?.filter((shop) => isTestUser || !shop.isTestShop),
        isBlank,
    };
}

export default useShops;
